import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import FieldOfStudy from "../components/FieldOfStudy";
import Financial from "../components/Financial";
import Footer from "../components/Footer";
import Gender from "../components/Gender";
import Header from "../components/Header";
import MaritalStatus from "../components/MaritalStatus";
import PreferredCountry from "../components/PreferredCountry";
import PreferredIntake from "../components/PreferredIntake";
import StudyLevel from "../components/StudyLevel";
import { contactJson } from "../modal/contactModal";
import { activityJson } from "../modal/activityModal";
import Tests from "../components/Tests";
import HowYouHeardAboutUs from "../components/HowYouHeardAboutUs";
import { insertContact } from "../actions/contactActions";
import Year from "../components/Year";
import { ContactCreateValidator1, GET_DATE } from "../Model/contactModel";
import { useParams } from "react-router-dom";

function Contact(props) {
  const dispatch = useDispatch();
  const [details, setDetails] = useState(contactJson);
  const [details2, setDetails2] = useState(contactJson);
  const [FormError, setFormError] = useState("");
  // const [id2, setid2] = useState(0);
  const [activity, setActivity] = useState(activityJson);
  const [recid, setrecid] = useState();
  const [recid2, setrecid2] = useState();
  const [Country, setCountry] = useState(false);
  const [Others, setOthers] = useState("");
  const { eventId } = useParams();
  // Three section for three parts:

  const [sec2, setSec2] = useState(true);
  const [sec3, setSec3] = useState(false);
  const [sec4, setSec4] = useState(false);

  const contactList = useSelector((state) => state.contactList);
  const { contacts, loading, error } = contactList;
  // console.log(details);
  const {
    contact: ContactId,
    success: successCreate,
    loading: loadingCreate,
    error: errorCreate,
  } = useSelector((state) => state.createContact);

  const handleClear = (e) => {
    e.preventDefault();
    setDetails({ ...contactJson });
    setrecid();
  };

  const handleChange = (e) => {
    setDetails({ ...details, [e.target.name]: e.target.value });
  };

  const handleActivityChange = (e) => {
    setActivity({ ...activity, [e.target.name]: e.target.value });
  };

  const handleActivityChangep = (vl) => {
    setActivity({ ...activity, preferreddegree: vl });
  };
  const handleActivityChangeCnt = (vl) => {
    if (vl?.split(",")?.includes("OTHERS")) {
      setCountry(true);
    } else {
      setCountry(false);
    }
    setActivity({ ...activity, preferredcountry: vl });
  };
  const handleActivityChangefin = (vl) => {
    setActivity({ ...activity, financialsource: vl });
  };
  const handleActivityChangetst = (vl) => {
    setActivity({ ...activity, testname: vl });
  };
  const handleActivityChangehd = (vl) => {
    setActivity({ ...activity, howyouheardaboutus: vl });
  };

  const save2ndStep = (e) => {
    e.preventDefault();
    window.scrollTo(0, 0);
    setFormError("");

    let Validator = ContactCreateValidator1({ ...details });

    if (Validator === "success") {
      setSec2(false);
      setSec3(true);
      setSec4(false);
    } else {
      setFormError(Validator);
    }
    // setSec1(false);
  };

  const save3rdStepPrev = (e) => {
    e.preventDefault();
    window.scrollTo(0, 0);

    // setSec1(false);
    setSec2(true);
    setSec3(false);
    setSec4(false);
  };

  const save3rdStep = (e) => {
    e.preventDefault();
    let validator = "success";
    setFormError("");
    let Validating = {
      preferreddegree: "Preferred Degree",
      preferredcountry: "Preferred Country",
      howyouheardaboutus: "How you hear about us",
    };
    var activityHtml = `<div className="container">
        <div className="row">
            <div className="col-md-12">
                <div className="table table-responsive">
                    <table className="table-striped">
                        <tr>
                            <td>Branch: $$Branch</td>
                            <td>Medium:Form <br/> <br/> Event: ${eventId}</td>
                        </tr>
                        <tr>
                            <td>Email Address: <br/> ${
                              details.Email_Address
                            }</td>
                            <td>Phone No: <br/>${details.Phone_No}</td>
                        </tr>
                        <tr>
                            <td>First Name: <br/> ${details.First_Name}</td>
                            <td>Last Name: <br/>${details.Last_Name}</td>
                        </tr>
                        <tr>
                            <td>Gender: <br/> ${
                              details.Gender.toString() == "1"
                                ? "Male"
                                : details.Gender.toString() == "2"
                                ? "Female"
                                : "Other"
                            }</td>
                            <td>Date of Birth: <br/>${
                              details.Date_Of_Birth ? details.Date_Of_Birth : ""
                            }</td>
                        </tr>
                        <tr>
                            <td>Marital Status: <br/> ${
                              details.Marital_Status === "1"
                                ? "Unmarried"
                                : details.Marital_Status === "2"
                                ? "Married"
                                : "Other"
                            }</td>
                            <td>Alternate Phone: <br/>${details.Phone_No1}</td>
                        </tr>
                        <tr>
                            <td>City: <br/> ${details.City}</td>
                            <td>State: <br/>${details.State}</td>
                        </tr>
                        <tr>
                            <td colspan="2">
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="table-responsive">
                                            <table className="table table-bordered">
                                                <thead>
                                                  <tr>
                                                    <th scope="col">Qualification</th>
                                                    <th scope="col">School /College</th>
                                                    <th scope="col">Board / University</th>
                                                    <th scope="col">Passing Year</th>
                                                    <th scope="col">Stream / Area</th>
                                                    <th scope="col">Percentage</th>
                                                  </tr>
                                                </thead>
                                                <tbody>
                                                  <tr>
                                                    <th> 10 + 2 / <br/>Diploma</th>
                                                    <td> ${activity.r11}</td>
                                                    <td> ${activity.r12}</td>
                                                    <td> ${activity.r13}</td>
                                                    <td> ${activity.r14}</td>
                                                    <td> ${activity.r15}</td>
                                                  </tr>
                                                  <tr>
                                                    <th> Bachelors / <br/>Graduation</th>
                                                    <td> ${activity.r21}</td>
                                                    <td> ${activity.r22}</td>
                                                    <td> ${activity.r23}</td>
                                                    <td> ${activity.r24}</td>
                                                    <td> ${activity.r25}</td>
                                                  </tr>
                                                  <tr>
                                                   <th> Masters</th>
                                                   <td> ${activity.r31}</td>
                                                   <td> ${activity.r32}</td>
                                                   <td> ${activity.r33}</td>
                                                   <td> ${activity.r34}</td>
                                                   <td> ${activity.r35}</td>
                                                  </tr>
                                                  <tr>
                                                   <th> Other</th>
                                                   <td> ${activity.r41}</td>
                                                   <td> ${activity.r42}</td>
                                                   <td> ${activity.r43}</td>
                                                   <td> ${activity.r44}</td>
                                                   <td> ${activity.r45}</td>
                                                  </tr>
                                                </tbody>
                                              </table>
                                        </div>
                                    </div>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>Preferred Degree: <br/>${
                              activity.preferreddegree
                            }</td>
                            <td>Preferred Country: <br/>${
                              activity.preferredcountry
                            }</td>
                            {${
                              Others
                                ? `<td>Preferred Country: <br/>${Others}</td>`
                                : ""
                            } }
                        </tr>

                        
                        <tr>
                            <td>Preferred Field of Study: <br/>${
                              activity.preferredfield
                            }</td>
                            <td>Preferred Intake: <br/>${
                              activity.preferredintake
                            }</td>
                        </tr>
                        <tr>
                            <td>Intake Year: <br/>${activity.preferredyear}</td>
                            <td>Financial Source: <br/>${
                              activity.financialsource
                            }</td>
                        </tr>
                        <tr>
                            <td>Work Experience: <br/>${
                              activity.workexperience
                            }</td>
                            <td>Years of Experience: <br/>${
                              activity.yearsexperience
                            }</td>
                        </tr>
                        <tr>
                            <td>Test Taken: <br/>${activity.testgiven}</td>
                            <td>Test Score: <br/>${activity.testscore}</td>
                        </tr>
                        <tr>
                            <td>Tests Names: <br/>${activity.testname}</td>
                            <td></td>
                        </tr>
                        <tr>
                            <td>Visa Status: <br/>${activity.visastatus}</td>
                            <td>Visa Details: <br/>${
                              activity.visaelaborate
                            }</td>
                        </tr>
                        <tr>
                            <td>How you heard about us: <br/>${
                              activity.howyouheardaboutus
                            }</td>
                            <td></td>
                        </tr>
                    </table>
                </div>
            </div>
        </div>
    </div>`;
    for (let key in Validating) {
      if (
        activity[key] === undefined ||
        activity[key]?.trim() === "" ||
        activity[key] === null
      ) {
        validator = `Error - ${Validating[key]} is required !`;
        break;
      }
    }

    var dt;
    if (eventId === "") {
      dt = {
        ...details,
        Activity: `Student Form Filled`,
        Activity_Des: activityHtml,
      };
    } else {
      dt = {
        ...details,
        Activity: `EventTaggedActivity${eventId}`,
        Activity_Des: activityHtml,
      };
    }
    if (validator === "success") {
      dispatch(insertContact(dt));
    } else {
      setFormError(validator);
    }

    // console.log(successCreate);
    // console.log(loadingCreate);
    // console.log(errorCreate);
  };

  const save4thStep = (e) => {
    e.preventDefault();
    window.location.reload();
  };

  useEffect(() => {
    if (successCreate) {
      window.scrollTo(0, 0);
      setSec2(false);
      setSec3(false);
      setSec4(true);
      setDetails(contactJson);
    }
    // console.log(details.Email_Address)
    // console.log(details);
    // console.log(typeof details);
    // console.log(contacts[0]);
    // console.log(typeof contacts[0]);

    // var dt = contacts[0];
    // console.log("dt");
    // console.log(typeof dt);
    // var dt1 = { ...details, ...dt };

    // console.log("merged");
    // console.log(dt1);

    // if (contacts == undefined) {
    //   setDetails(dt1);
    // }

    // if (details.Email_Address == "") {
    //   var dt1 = contacts[0];
    //   var dt = [...details, dt1];
    //   setDetails(dt);
    //   //setDetails({...})
    // }
  }, [dispatch, successCreate]);

  useEffect(() => {
    if (details.City === "--") {
      setDetails2({ ...details, City: "" });
    }

    if (details?.Date_Of_Birth) {
      setDetails2({
        ...details,
        Date_Of_Birth: GET_DATE(details?.Date_Of_Birth),
      });
    } else {
      setDetails2({
        ...details,
        Date_Of_Birth: "",
      });
    }
  }, [details]);

  useEffect(() => {
    if (details.Email_Address === "" || recid !== recid2) {
      if (contacts !== undefined) {
        if (contacts.length > 0) {
          var dt = { ...details, ...contacts[0] };
          setDetails2({ ...details, ...contacts[0] });
          setrecid2(recid);
        }
      }
    }
  }, [details, contacts]);

  return (
    <>
      <Header />
      <div className="custom-header">
        <div className="speaking-evaluation">
          <div className="speaking-evaluationOverlay"></div>
          <img
            src="../assets/img/speaking-banner.jpg"
            alt="speaking-banner"
            className="img-fluid"
          />
          <div className="container">
            <div className="speaking-evaluation_title">
              <h1>Registration Form</h1>
            </div>
          </div>
        </div>
      </div>

      {/* Main Body */}
      <section className="section-padding bg-f3f3f3">
        <div className="container">
          <div className="section-body">
            <div className="speaking-evaluation-body p-lg-5">
              <div className="seaking-evaluation-from">
                <div className="studentDashboard">
                  <div
                    className="my-application Registration-from"
                    id="myApplication"
                  >
                    <div className="row">
                      <div
                        className="col-md-12 "
                        style={{
                          marginTop:
                            window.innerWidth <= 480 ? "-20px" : "-50px",
                          textAlign: "right",
                        }}
                      >
                        {sec4 ? (
                          ""
                        ) : (
                          <button
                            onClick={handleClear}
                            className="btn btn-link"
                          >
                            Clear
                          </button>
                        )}
                      </div>

                      <div className="col-md-12">
                        <div className="custom-tab-details">
                          <div className="tab-content" id="v-pills-tabContent">
                            {/* Office Use Section */}
                            {/*sec1 ? (
                              <div className="tab-pane active">
                                <div className="officeUse mb-5 mt-3">
                                  <h2>For office use only</h2>
                                  <span className="CourseDescription-broder-btm  mb-4"></span>
                                  <div className="row">
                                    <div className="col-md-4">
                                      <div className="form-group">
                                        <label>Branch :</label>
                                        <select
                                          className=" form-control form-control-sm"
                                          name="Branch"
                                          id="Branch"
                                          value={details.Branch}
                                          onChange={handleChange}
                                        >
                                          <option value="">--Select--</option>
                                          <Branch />
                                        </select>
                                      </div>
                                    </div>
                                    <div className="col-md-4">
                                      <div className="form-group">
                                        <label>Medium :</label>
                                        <select
                                          className=" form-control form-control-sm"
                                          name="medium"
                                          id="medium"
                                          value={activity.medium}
                                          onChange={handleActivityChange}
                                        >
                                          <option>--Select--</option>
                                          <option value="Office">
                                            Office Visit
                                          </option>
                                          <option value="Call">Call</option>
                                          <option value="Event">Event</option>
                                        </select>
                                      </div>
                                    </div>
                                    <div className="col-md-4">
                                      <div className="form-group">
                                        <label>Event :</label>
                                        <select
                                          className=" form-control form-control-sm"
                                          name="eventId"
                                          id="eventId"
                                          value={activity.eventId}
                                          onChange={handleActivityChange}
                                        >
                                          <option value="">--Select--</option>
                                          <Event />
                                        </select>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            ) : (
                              <></>
                            )*/}

                            {/* Personal Information Section */}
                            {sec2 ? (
                              <div className="tab-pane active">
                                <div className="row">
                                  <div className="col-md-12">
                                    <h2>Personal Information</h2>
                                    <span className="CourseDescription-broder-btm"></span>
                                  </div>

                                  <div className="col-md-6">
                                    <div className="form-group">
                                      <label>
                                        Email Address<span>*</span>:
                                      </label>
                                      <input
                                        type="text"
                                        className="form-control form-control-sm"
                                        autoComplete="nope"
                                        placeholder="Email Address"
                                        name="Email_Address"
                                        required
                                        value={details.Email_Address}
                                        onChange={handleChange}
                                      />
                                    </div>
                                  </div>

                                  <div className="col-md-6">
                                    <div className="form-group">
                                      <label>
                                        Mobile Number<span>*</span>:
                                      </label>
                                      <input
                                        type="number"
                                        className="form-control form-control-sm"
                                        autoComplete="nope"
                                        placeholder="Enter Number"
                                        name="Phone_No"
                                        required
                                        value={details.Phone_No}
                                        onChange={handleChange}
                                      />
                                    </div>
                                  </div>

                                  <div className="col-md-6">
                                    <div className="form-group">
                                      <label>
                                        First Name<span>*</span>:
                                      </label>
                                      <input
                                        type="text"
                                        className="form-control form-control-sm"
                                        placeholder="First Name"
                                        autoComplete="nope"
                                        required
                                        name="First_Name"
                                        value={details.First_Name}
                                        onChange={handleChange}
                                      />
                                    </div>
                                  </div>

                                  <div className="col-md-6">
                                    <div className="form-group">
                                      <label>
                                        Last Name<span>*</span>:
                                      </label>
                                      <input
                                        type="text"
                                        className="form-control form-control-sm"
                                        placeholder="Last Name"
                                        autoComplete="nope"
                                        required
                                        name="Last_Name"
                                        value={details.Last_Name}
                                        onChange={handleChange}
                                      />
                                    </div>
                                  </div>
                                  <div className="col-md-6">
                                    <div className="form-group">
                                      <label>
                                        Date of Birth<span></span>:
                                      </label>
                                      <input
                                        type="date"
                                        className="form-control form-control-sm"
                                        autoComplete="nope"
                                        placeholder="DD/MM/YYYY"
                                        name="Date_Of_Birth"
                                        required
                                        value={
                                          details?.Date_Of_Birth
                                          // ? GET_DATE(details.Date_Of_Birth)
                                          // : ""
                                        }
                                        onChange={handleChange}
                                      />
                                    </div>
                                  </div>
                                  <div className="col-md-6">
                                    <div className="form-group">
                                      <label>
                                        Gender<span>*</span>:
                                      </label>
                                      <select
                                        className=" form-control form-control-sm"
                                        required
                                        name="Gender"
                                        value={details.Gender}
                                        onChange={handleChange}
                                      >
                                        <option value="">--Select--</option>
                                        <Gender />
                                      </select>
                                    </div>
                                  </div>
                                  <div className="col-md-6">
                                    <div className="form-group">
                                      <label>
                                        Marital status<span>*</span>:
                                      </label>
                                      <select
                                        className=" form-control form-control-sm"
                                        name="Marital_Status"
                                        required
                                        value={details.Marital_Status}
                                        onChange={handleChange}
                                      >
                                        <option value="">--Select--</option>
                                        <MaritalStatus />
                                      </select>
                                    </div>
                                  </div>

                                  <div className="col-md-6">
                                    <div className="form-group">
                                      <label>Alternate Mobile Number:</label>
                                      <input
                                        type="text"
                                        className="form-control form-control-sm"
                                        name="Phone_No1"
                                        autoComplete="nope"
                                        placeholder="Enter Alternate Number"
                                        value={details.Phone_No1}
                                        onChange={handleChange}
                                      />
                                    </div>
                                  </div>

                                  <div className="col-md-6">
                                    <div className="form-group">
                                      <label>
                                        City<span>*</span>:
                                      </label>
                                      <input
                                        type="text"
                                        className="form-control form-control-sm"
                                        autoComplete="nope"
                                        placeholder="Enter City"
                                        name="City"
                                        required
                                        value={details.City}
                                        onChange={handleChange}
                                      />
                                    </div>
                                  </div>
                                  <div className="col-md-6">
                                    <div className="form-group">
                                      <label>
                                        State<span>*</span>:
                                      </label>
                                      <input
                                        type="text"
                                        className="form-control form-control-sm"
                                        autoComplete="nope"
                                        placeholder="Enter State"
                                        name="State"
                                        value={details.State}
                                        onChange={handleChange}
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            ) : (
                              <></>
                            )}

                            {/* Education Detail Section */}
                            {sec3 ? (
                              <div className="tab-pane active">
                                <div className="row">
                                  <div className="col-md-12 mt-3">
                                    <h2>Educational Qualifications</h2>
                                    <span className="CourseDescription-broder-btm"></span>
                                  </div>

                                  {/* <div className="col-md-12">
                                    <div className="qualify-table">
                                      <div className="table-responsive">
                                        <table
                                          style={{ border: "0.1px solid grey" }}
                                          className="table table-bordered"
                                        >
                                          <thead>
                                            <tr>
                                              <th scope="col">Qualification</th>
                                              <th scope="col">
                                                School /College
                                              </th>
                                              <th scope="col">
                                                Board / University
                                              </th>
                                              <th scope="col">Passing Year</th>
                                              <th scope="col">Stream / Area</th>
                                              <th scope="col">Percentage</th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            <tr>
                                              <th> 10 + 2</th>
                                              <td>
                                                {" "}
                                                <input
                                                  type="text"
                                                  name="r11"
                                                  className="form-control form-control-sm"
                                                  value={activity.r11}
                                                  onChange={
                                                    handleActivityChange
                                                  }
                                                />
                                              </td>
                                              <td>
                                                {" "}
                                                <input
                                                  type="text"
                                                  name="r12"
                                                  className="form-control form-control-sm"
                                                  value={activity.r12}
                                                  onChange={
                                                    handleActivityChange
                                                  }
                                                />
                                              </td>
                                              <td>
                                                {" "}
                                                <input
                                                  type="text"
                                                  name="r13"
                                                  className="form-control form-control-sm"
                                                  value={activity.r13}
                                                  onChange={
                                                    handleActivityChange
                                                  }
                                                />
                                              </td>
                                              <td>

                                                <input
                                                  type="text"
                                                  className="form-control form-control-sm"
                                                  name="r14"
                                                  value={activity.r14}
                                                  onChange={
                                                    handleActivityChange
                                                  }
                                                />
                                              </td>
                                              <td>
                                                <input
                                                  type="text"
                                                  name="r15"
                                                  className="form-control form-control-sm"
                                                  value={activity.r15}
                                                  onChange={
                                                    handleActivityChange
                                                  }
                                                />
                                              </td>
                                            </tr>
                                            <tr>
                                              <th> Graduation</th>
                                              <td>
                                                {" "}
                                                <input
                                                  type="text"
                                                  name="r21"
                                                  className="form-control form-control-sm"
                                                  value={activity.r21}
                                                  onChange={
                                                    handleActivityChange
                                                  }
                                                />
                                              </td>
                                              <td>
                                                <input
                                                  type="text"
                                                  name="r22"
                                                  className="form-control form-control-sm"
                                                  value={activity.r22}
                                                  onChange={
                                                    handleActivityChange
                                                  }
                                                />
                                              </td>
                                              <td>
                                                <input
                                                  type="text"
                                                  name="r23"
                                                  className="form-control form-control-sm"
                                                  value={activity.r23}
                                                  onChange={
                                                    handleActivityChange
                                                  }
                                                />
                                              </td>
                                              <td>
                                                <input
                                                  type="text"
                                                  name="r24"
                                                  className="form-control form-control-sm"
                                                  value={activity.r24}
                                                  onChange={
                                                    handleActivityChange
                                                  }
                                                />
                                              </td>
                                              <td>
                                                <input
                                                  type="text"
                                                  name="r25"
                                                  className="form-control form-control-sm"
                                                  value={activity.r25}
                                                  onChange={
                                                    handleActivityChange
                                                  }
                                                />
                                              </td>
                                            </tr>
                                            <tr>
                                              <th> Masters</th>
                                              <td>
                                                <input
                                                  type="text"
                                                  name="r31"
                                                  className="form-control form-control-sm"
                                                  value={activity.r31}
                                                  onChange={
                                                    handleActivityChange
                                                  }
                                                />
                                              </td>
                                              <td>
                                                <input
                                                  type="text"
                                                  name="r32"
                                                  className="form-control form-control-sm"
                                                  value={activity.r32}
                                                  onChange={
                                                    handleActivityChange
                                                  }
                                                />
                                              </td>
                                              <td>
                                                <input
                                                  type="text"
                                                  name="r33"
                                                  className="form-control form-control-sm"
                                                  value={activity.r33}
                                                  onChange={
                                                    handleActivityChange
                                                  }
                                                />
                                              </td>
                                              <td>
                                                <input
                                                  type="text"
                                                  name="r34"
                                                  className="form-control form-control-sm"
                                                  value={activity.r34}
                                                  onChange={
                                                    handleActivityChange
                                                  }
                                                />
                                              </td>
                                              <td>
                                                <input
                                                  type="text"
                                                  name="r35"
                                                  className="form-control form-control-sm"
                                                  value={activity.r35}
                                                  onChange={
                                                    handleActivityChange
                                                  }
                                                />
                                              </td>
                                            </tr>
                                            <tr>
                                              <th> Other</th>
                                              <td>
                                                <input
                                                  type="text"
                                                  name="r41"
                                                  className="form-control form-control-sm"
                                                  value={activity.r41}
                                                  onChange={
                                                    handleActivityChange
                                                  }
                                                />
                                              </td>
                                              <td>
                                                <input
                                                  type="text"
                                                  name="r42"
                                                  className="form-control form-control-sm"
                                                  value={activity.r42}
                                                  onChange={
                                                    handleActivityChange
                                                  }
                                                />
                                              </td>
                                              <td>
                                                <input
                                                  type="text"
                                                  name="r43"
                                                  className="form-control form-control-sm"
                                                  value={activity.r43}
                                                  onChange={
                                                    handleActivityChange
                                                  }
                                                />
                                              </td>
                                              <td>
                                                <input
                                                  type="text"
                                                  name="r44"
                                                  className="form-control form-control-sm"
                                                  value={activity.r44}
                                                  onChange={
                                                    handleActivityChange
                                                  }
                                                />
                                              </td>
                                              <td>
                                                <input
                                                  type="text"
                                                  name="r45"
                                                  className="form-control form-control-sm"
                                                  value={activity.r45}
                                                  onChange={
                                                    handleActivityChange
                                                  }
                                                />
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </div>
                                    </div>
                                  </div> */}

                                  {/* 10+2 */}

                                  <div className="col-md-12">
                                    <div className=" mt-3">
                                      <h6 style={{ margin: "0", padding: "0" }}>
                                        Qualification
                                      </h6>
                                      <span className="CourseDescription-broder-btm-2"></span>
                                    </div>
                                    <div className=" mt-3">
                                      <h6 style={{ margin: "0", padding: "0" }}>
                                        10 + 2 :
                                      </h6>
                                      <span className="CourseDescription-broder-btm-2"></span>
                                    </div>

                                    <div className="Education1">
                                      <div className="form-group">
                                        <label>College /School :</label>
                                        <input
                                          type="text"
                                          name="r11"
                                          className="form-control form-control-sm"
                                          value={activity.r11}
                                          onChange={handleActivityChange}
                                        />
                                      </div>
                                      <div className="form-group">
                                        <label>Board / University :</label>
                                        <input
                                          type="text"
                                          name="r12"
                                          className="form-control form-control-sm"
                                          value={activity.r12}
                                          onChange={handleActivityChange}
                                        />
                                      </div>
                                      <div className="form-group">
                                        <label>Passing Year :</label>
                                        <input
                                          type="text"
                                          name="r13"
                                          className="form-control form-control-sm"
                                          value={activity.r13}
                                          onChange={handleActivityChange}
                                        />
                                      </div>
                                      <div className="form-group">
                                        <label>Stream / Area :</label>
                                        <input
                                          type="text"
                                          name="r14"
                                          className="form-control form-control-sm"
                                          value={activity.r14}
                                          onChange={handleActivityChange}
                                        />
                                      </div>
                                      <div className="form-group">
                                        <label>Percentage :</label>
                                        <input
                                          type="text"
                                          name="r15"
                                          className="form-control form-control-sm"
                                          value={activity.r15}
                                          onChange={handleActivityChange}
                                        />
                                      </div>
                                    </div>
                                  </div>

                                  {/* Graduation */}

                                  <div className="col-md-12">
                                    <div className=" mt-3">
                                      <h6 style={{ margin: "0", padding: "0" }}>
                                        Graduation :
                                      </h6>
                                      <span className="CourseDescription-broder-btm-2"></span>
                                    </div>

                                    <div className="Education1">
                                      <div className="form-group">
                                        <label>College /School :</label>
                                        <input
                                          type="text"
                                          name="r21"
                                          className="form-control form-control-sm"
                                          value={activity.r21}
                                          onChange={handleActivityChange}
                                        />
                                      </div>
                                      <div className="form-group">
                                        <label>Board / University :</label>
                                        <input
                                          type="text"
                                          name="r22"
                                          className="form-control form-control-sm"
                                          value={activity.r22}
                                          onChange={handleActivityChange}
                                        />
                                      </div>
                                      <div className="form-group">
                                        <label>Passing Year :</label>
                                        <input
                                          type="text"
                                          name="r23"
                                          className="form-control form-control-sm"
                                          value={activity.r23}
                                          onChange={handleActivityChange}
                                        />
                                      </div>
                                      <div className="form-group">
                                        <label>Stream / Area :</label>
                                        <input
                                          type="text"
                                          name="r24"
                                          className="form-control form-control-sm"
                                          value={activity.r24}
                                          onChange={handleActivityChange}
                                        />
                                      </div>
                                      <div className="form-group">
                                        <label>Percentage :</label>
                                        <input
                                          type="text"
                                          name="r25"
                                          className="form-control form-control-sm"
                                          value={activity.r25}
                                          onChange={handleActivityChange}
                                        />
                                      </div>
                                    </div>
                                  </div>

                                  {/* Master */}

                                  <div className="col-md-12">
                                    <div className=" mt-3">
                                      <h6 style={{ margin: "0", padding: "0" }}>
                                        Masters :
                                      </h6>
                                      <span className="CourseDescription-broder-btm-2"></span>
                                    </div>

                                    <div className="Education1">
                                      <div className="form-group">
                                        <label>College /School :</label>
                                        <input
                                          type="text"
                                          name="r31"
                                          className="form-control form-control-sm"
                                          value={activity.r31}
                                          onChange={handleActivityChange}
                                        />
                                      </div>
                                      <div className="form-group">
                                        <label>Board / University :</label>
                                        <input
                                          type="text"
                                          name="r32"
                                          className="form-control form-control-sm"
                                          value={activity.r32}
                                          onChange={handleActivityChange}
                                        />
                                      </div>
                                      <div className="form-group">
                                        <label>Passing Year :</label>
                                        <input
                                          type="text"
                                          name="r33"
                                          className="form-control form-control-sm"
                                          value={activity.r33}
                                          onChange={handleActivityChange}
                                        />
                                      </div>
                                      <div className="form-group">
                                        <label>Stream / Area :</label>
                                        <input
                                          type="text"
                                          name="r34"
                                          className="form-control form-control-sm"
                                          value={activity.r34}
                                          onChange={handleActivityChange}
                                        />
                                      </div>
                                      <div className="form-group">
                                        <label>Percentage :</label>
                                        <input
                                          type="text"
                                          name="r35"
                                          className="form-control form-control-sm"
                                          value={activity.r35}
                                          onChange={handleActivityChange}
                                        />
                                      </div>
                                    </div>
                                  </div>

                                  {/* Others */}

                                  <div className="col-md-12">
                                    <div className="mt-3">
                                      <h6 style={{ margin: "0", padding: "0" }}>
                                        Others :
                                      </h6>
                                      <span className="CourseDescription-broder-btm-2"></span>
                                    </div>

                                    <div className="Education1">
                                      <div className="form-group">
                                        <label>College /School :</label>
                                        <input
                                          type="text"
                                          name="r41"
                                          className="form-control form-control-sm"
                                          value={activity.r41}
                                          onChange={handleActivityChange}
                                        />
                                      </div>
                                      <div className="form-group">
                                        <label>Board / University :</label>
                                        <input
                                          type="text"
                                          name="r42"
                                          className="form-control form-control-sm"
                                          value={activity.r42}
                                          onChange={handleActivityChange}
                                        />
                                      </div>
                                      <div className="form-group">
                                        <label>Passing Year :</label>
                                        <input
                                          type="text"
                                          name="r43"
                                          className="form-control form-control-sm"
                                          value={activity.r43}
                                          onChange={handleActivityChange}
                                        />
                                      </div>
                                      <div className="form-group">
                                        <label>Stream / Area :</label>
                                        <input
                                          type="text"
                                          name="r44"
                                          className="form-control form-control-sm"
                                          value={activity.r44}
                                          onChange={handleActivityChange}
                                        />
                                      </div>
                                      <div className="form-group">
                                        <label>Percentage :</label>
                                        <input
                                          type="text"
                                          name="r45"
                                          className="form-control form-control-sm"
                                          value={activity.r45}
                                          onChange={handleActivityChange}
                                        />
                                      </div>
                                    </div>
                                  </div>

                                  {/* End education details */}
                                  <div className="col-md-12">
                                    <div className="country-option form-group options">
                                      <h6>
                                        Preferred Degree{" "}
                                        <span style={{ color: "red" }}>*</span>:
                                      </h6>
                                      <StudyLevel
                                        handleAchange={(vl) =>
                                          handleActivityChangep(vl)
                                        }
                                      />
                                    </div>
                                  </div>

                                  <div className="col-md-12">
                                    <div className="country-option form-group options">
                                      <h6>
                                        Preferred Country{" "}
                                        <span style={{ color: "red" }}>*</span>:
                                      </h6>

                                      <PreferredCountry
                                        handleAchange={(vl) =>
                                          handleActivityChangeCnt(vl)
                                        }
                                      />
                                    </div>
                                    {Country ? (
                                      <div
                                        style={{ marginBottom: "4px" }}
                                        className="col-md-6 col-4"
                                      >
                                        <input
                                          type="text"
                                          className="form-control form-control-sm"
                                          name="Others"
                                          placeholder="Enter Country Name"
                                          value={Others}
                                          onChange={(e) =>
                                            setOthers(e.target.value)
                                          }
                                        />
                                      </div>
                                    ) : (
                                      ""
                                    )}
                                  </div>

                                  <div className="col-md-4 mt-1">
                                    <div className="form-group">
                                      <h6>Preferred Field of Study:</h6>
                                      <select
                                        className=" form-control form-control-sm"
                                        name="preferredfield"
                                        value={activity.preferredfield}
                                        onChange={handleActivityChange}
                                      >
                                        <option value="">--Select--</option>
                                        <FieldOfStudy />
                                        <option value="Other">Other</option>
                                      </select>
                                    </div>
                                  </div>

                                  {activity?.preferredfield == "Other" ? (
                                    <div className="col-md-4 mt-1">
                                      <div className="form-group">
                                        <h6>Enter Study Details</h6>
                                        <input
                                          type="text"
                                          className="form-control form-control-sm"
                                          name="Others"
                                          placeholder="Enter Study details"
                                          value={Others}
                                          onChange={(e) =>
                                            setOthers(e.target.value)
                                          }
                                        />
                                      </div>
                                    </div>
                                  ) : (
                                    ""
                                  )}
                                </div>
                                <div className="row">
                                  <div className="col-md-4 mt-1">
                                    <div className="form-group">
                                      <h6>Preferred Intake:</h6>
                                      <select
                                        className=" form-control form-control-sm"
                                        name="preferredintake"
                                        value={activity.preferredintake}
                                        onChange={handleActivityChange}
                                      >
                                        <option value="">--Select--</option>
                                        <PreferredIntake />
                                      </select>
                                    </div>
                                  </div>

                                  <div className="col-md-4 mt-1">
                                    <div className="form-group">
                                      <h6>Preferred Intake Year:</h6>
                                      <select
                                        className=" form-control form-control-sm"
                                        name="preferredyear"
                                        value={activity.preferredyear}
                                        onChange={handleActivityChange}
                                      >
                                        <option value="">--Select--</option>

                                        <Year />
                                      </select>
                                    </div>
                                  </div>

                                  <div className="col-md-12 mt-2">
                                    <div className="country-option form-group options">
                                      <h6>Financial Source:</h6>
                                      <Financial
                                        handleAchange={(vl) =>
                                          handleActivityChangefin(vl)
                                        }
                                      />
                                    </div>
                                  </div>

                                  <div className="col-md-6">
                                    <div className="form-group">
                                      <h6>Work Experience:</h6>
                                      <div className="row">
                                        <div className="col-md-3 col-2">
                                          <div className="form-check">
                                            <label
                                              className="form-check-label"
                                              for="select1"
                                            >
                                              <input
                                                type="radio"
                                                className="form-check-input"
                                                name="workexperience"
                                                checked={
                                                  activity?.workexperience ===
                                                  "YES"
                                                    ? false
                                                    : true
                                                }
                                                value={"NO"}
                                                onChange={handleActivityChange}
                                              />
                                              NO
                                            </label>
                                          </div>
                                        </div>

                                        <div className="col-md-3 col-2">
                                          <div className="form-check">
                                            <label
                                              className="form-check-label"
                                              for="select2"
                                            >
                                              <input
                                                type="radio"
                                                className="form-check-input"
                                                chekced={
                                                  !activity?.workexperience ===
                                                  "YES"
                                                    ? false
                                                    : true
                                                }
                                                name="workexperience"
                                                value="YES"
                                                onChange={handleActivityChange}
                                              />
                                              YES
                                            </label>
                                          </div>
                                        </div>
                                        {activity?.workexperience === "YES" ? (
                                          <div className="col-md-6 col-4">
                                            <input
                                              type="text"
                                              className="form-control form-control-sm"
                                              name="yearsexperience"
                                              placeholder="Years of Experience"
                                              value={activity.yearsexperience}
                                              onChange={handleActivityChange}
                                            />
                                          </div>
                                        ) : (
                                          ""
                                        )}
                                      </div>
                                    </div>
                                  </div>

                                  <div className="col-md-12 mt-2">
                                    <div className="country-option form-group options">
                                      <div className="row">
                                        <h6 className="pl-3">
                                          Have you given any of following tests,
                                          if yes fill the test scores:{" "}
                                        </h6>
                                        <div className="col-md-1 col-2">
                                          <div className="form-check">
                                            <label
                                              className="form-check-label"
                                              for="select3"
                                            >
                                              <input
                                                type="radio"
                                                className="form-check-input"
                                                name="testgiven"
                                                checked={
                                                  activity.testgiven === "No"
                                                    ? true
                                                    : false
                                                }
                                                value="No"
                                                onChange={handleActivityChange}
                                              />
                                              NO
                                            </label>
                                          </div>
                                        </div>

                                        <div className="col-md-1 col-2">
                                          <div className="form-check">
                                            <label
                                              className="form-check-label"
                                              for="select4"
                                            >
                                              <input
                                                type="radio"
                                                className="form-check-input "
                                                name="testgiven"
                                                checked={
                                                  activity.testgiven === "Yes"
                                                    ? true
                                                    : false
                                                }
                                                value="Yes"
                                                onChange={handleActivityChange}
                                              />
                                              YES
                                            </label>
                                          </div>
                                        </div>
                                      </div>
                                      <div>
                                        {activity?.testgiven === "Yes" ? (
                                          <div className="col-md-4">
                                            <div className="form-group">
                                              <h6>Enter Test Score</h6>
                                              <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                name="testscore"
                                                placeholder="Test Score"
                                                value={activity.testscore}
                                                onChange={handleActivityChange}
                                              />
                                            </div>
                                          </div>
                                        ) : (
                                          ""
                                        )}
                                      </div>
                                      <Tests
                                        handleAchange={(vl) =>
                                          handleActivityChangetst(vl)
                                        }
                                      />
                                    </div>
                                  </div>

                                  <div className="col-md-12 mt-2">
                                    <div className="country-option form-group options">
                                      <div className="row">
                                        <h6 className="pl-3">
                                          Have you or your spouse had any Visa
                                          Approval/ Rejection history or had
                                          lodged PR to any country, if yes
                                          (Elaborate):
                                        </h6>
                                        <div className="col-md-1 col-2">
                                          <div className="form-check">
                                            <label
                                              className="form-check-label"
                                              for="select5"
                                            >
                                              <input
                                                type="radio"
                                                className="form-check-input"
                                                name="visastatus"
                                                checked={
                                                  activity.visastatus === "No"
                                                    ? true
                                                    : false
                                                }
                                                value="No"
                                                onChange={handleActivityChange}
                                              />
                                              NO
                                            </label>
                                          </div>
                                        </div>

                                        <div className="col-md-1 col-1">
                                          <div className="form-check">
                                            <label
                                              className="form-check-label"
                                              for="select6"
                                            >
                                              <input
                                                type="radio"
                                                className="form-check-input "
                                                name="visastatus"
                                                checked={
                                                  activity.visastatus === "Yes"
                                                    ? true
                                                    : false
                                                }
                                                value="Yes"
                                                onChange={handleActivityChange}
                                              />
                                              YES
                                            </label>
                                          </div>
                                        </div>
                                        {activity?.visastatus === "Yes" ? (
                                          <div className="col-md-12 col-12">
                                            <textarea
                                              className="form-control"
                                              name="visaelaborate"
                                              cols="20"
                                              rows="2"
                                              value={activity.visaelaborate}
                                              onChange={handleActivityChange}
                                            ></textarea>
                                          </div>
                                        ) : (
                                          ""
                                        )}
                                      </div>
                                    </div>
                                  </div>

                                  <div className="col-md-12 mt-2">
                                    <div className="country-option form-group options">
                                      <h6>
                                        How did you hear about us{" "}
                                        <span style={{ color: "red" }}>*</span>:
                                      </h6>
                                      <HowYouHeardAboutUs
                                        handleAchange={(vl) =>
                                          handleActivityChangehd(vl)
                                        }
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            ) : (
                              <></>
                            )}

                            {sec4 ? (
                              <div className="tab-pane active">
                                <div className="row">
                                  <div className="col-md-12">
                                    <p>
                                      Thanks for the registration. Your
                                      Registration Id is:{" "}
                                      <strong style={{ fontSize: 30 }}>
                                        {ContactId}
                                      </strong>
                                    </p>
                                    <span className="CourseDescription-broder-btm  mb-4"></span>
                                  </div>
                                </div>
                              </div>
                            ) : (
                              <></>
                            )}
                          </div>

                          <div className="row">
                            {FormError ? (
                              <p
                                style={{
                                  textAlign: "center",
                                  color: "red",
                                  margin: "0",
                                  padding: "0",
                                }}
                              >
                                {FormError}
                              </p>
                            ) : (
                              ""
                            )}
                            <div className="col-md-12 custom-form-btn mt-3 text-center">
                              {/* <p>Error :- All fields are compulsory</p> */}
                              {/*sec1 ? (
                                <button
                                  className="btn form-savebtn"
                                  id="showSucsess"
                                  onClick={(e) => save1stStep(e)}
                                >
                                  Save
                                </button>
                              ) : (
                                <></>
                              )*/}
                              {sec2 ? (
                                <>
                                  {/* <button
                                    className=" btn form-savebtn"
                                    id="showSucsess"
                                    onClick={(e) => save2ndStepPrev(e)}
                                  >
                                    Go Back
                                  </button> */}

                                  <span>&nbsp;</span>

                                  <button
                                    className=" btn form-savebtn"
                                    id="showSucsess"
                                    onClick={(e) => save2ndStep(e)}
                                  >
                                    Save and Continue
                                  </button>
                                </>
                              ) : (
                                <></>
                              )}
                              {sec3 ? (
                                <>
                                  {loadingCreate ? (
                                    <div>Loading...</div>
                                  ) : (
                                    <>
                                      <button
                                        type="button"
                                        className=" btn form-savebtn"
                                        id="showSucsess"
                                        onClick={(e) => save3rdStepPrev(e)}
                                      >
                                        Go Back
                                      </button>

                                      <span>&nbsp;</span>

                                      <button
                                        type="button"
                                        className=" btn form-savebtn"
                                        id="showSucsess"
                                        onClick={(e) => save3rdStep(e)}
                                      >
                                        Submit
                                      </button>
                                      <p>{errorCreate}</p>
                                    </>
                                  )}
                                </>
                              ) : (
                                <></>
                              )}
                              {sec4 ? (
                                <>
                                  <button
                                    className=" btn form-savebtn"
                                    id="showSucsess"
                                    onClick={(e) => save4thStep(e)}
                                  >
                                    New Registration
                                  </button>
                                </>
                              ) : (
                                <></>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <Footer />
    </>
  );
}

export default Contact;
